
'use strict';

var React = require('react');
var PropTypes = require('prop-types');

module.exports = function render(props) {
    var innerHtml = '<path d="M19.712 11.562c-.8.99-1.57 1.929-8.08 7.218a.99.99 0 0 1-.63.22c-.22 0-.44-.07-.63-.22-6.48-5.24-7.27-6.208-8.1-7.228-1.7-2.07-2.49-4.38-2.22-6.49.22-1.668 1.07-3.118 2.4-4.088 2.42-1.75 5.83-1.09 8.55 1.56 2.74-2.63 6.14-3.29 8.53-1.56a5.937 5.937 0 0 1 2.42 4.119c.26 2.11-.53 4.399-2.24 6.469"/><!-- Filename: sourceSvg/action/favorite_selected.svg -->';
    var svgProps = {
        className: props.className ? (props.className + ' uig-svg-icon') : 'uig-svg-icon',
        dangerouslySetInnerHTML: {__html: innerHtml },
        viewBox: '0 0 22 19'
    }
    return React.createElement('svg', Object.assign({}, props, svgProps));
}
    